import React, { useState } from 'react'
import AccordionServicos from './accordionServicos'
import CardServicos from './cardServicos'
import Container from './container'
import OtimizeSeuNegocio from './OtimizeSeuNegocio'

export default function SquadBeneficios({ title, cards = [] }) {
  const [expandedMobileIndex, setExpandedMobileIndex] = useState(null)
  
  // Handle accordion toggle in mobile view - exactly like in etapas.jsx
  const handleAccordionToggle = (index, isOpen) => {
    if (isOpen) {
      // Close any previously opened accordion
      if (expandedMobileIndex !== null && expandedMobileIndex !== index) {
        // Find the previously opened accordion and close it
        const prevAccordion = document.querySelector(`[data-accordion-index="${expandedMobileIndex}"]`);
        if (prevAccordion) {
          prevAccordion.click();
        }
      }
      setExpandedMobileIndex(index);
    } else if (expandedMobileIndex === index) {
      setExpandedMobileIndex(null);
    }
  }
  // Check if we have exactly 3 cards for special layout
  const hasExactlyThreeCards = cards.length === 3
  // Check if we have more than 3 cards (for mobile accordion)
  const hasMoreThanThreeCards = cards.length > 3

  // Split cards into rows based on the number of cards
  const firstRowCards = hasExactlyThreeCards ? [] : cards.slice(0, 2) // First row has text + 2 cards when not 3 cards
  const secondRowCards = hasExactlyThreeCards ? cards : cards.slice(2) // All 3 cards in one row or remaining cards

  return (
    <div className="w-full bg-[#040116] pt-[71px] pb-20 lg:py-32 relative overflow-hidden">
      {/* Background com grafismos */}
      <div className="absolute inset-0 opacity-10">
        <img
          src="/assets/grafismos.svg"
          alt="Grafismos"
          className="w-full h-full object-cover"
        />
        <img
          src="/assets/grafismos.svg"
          alt="Grafismos"
          className="absolute inset-0 w-full h-full object-cover rotate-180"
        />
      </div>

      <Container className="hidden lg:block relative z-10">
        {/* Special layout for exactly 3 cards */}
        {cards.length === 3 ? (
          <>
            {/* Title centered above cards */}
            <div className="text-5xl text-white flex justify-center mb-24">{title}</div>

            {/* All 3 cards in one row */}
            <div className="grid grid-cols-3 gap-6">
              {cards.map((card, index) => (
                <div key={index} className="relative">
                  <CardServicos
                    icon={card.icon}
                    iconHover={card.iconHover || card.icon}
                    title={card.title}
                    text={card.text}
                    glowColor={card.glowColor || '#A002CB'}
                    url={card.url}
                  />

                </div>
              ))}
            </div>
          </>
        ) : (
          <>
            {/* Standard layout for other card counts */}
            <div className="grid grid-cols-3 gap-4 mb-4">
              {/* Text Column */}
              <div className="text-5xl text-white flex items-center justify-center h-full">
                {title}
              </div>

              {/* First row cards */}
              {firstRowCards.map((card, index) => (
                <div key={index} className="relative">
                  <CardServicos
                    icon={card.icon}
                    iconHover={card.iconHover || card.icon}
                    title={card.title}
                    text={card.text}
                    glowColor={card.glowColor || '#A002CB'}
                    url={card.url}
                    className="w-full md:w-auto"
                  />

                </div>
              ))}
            </div>
          </>
        )}

        {/* Second row with remaining cards (only for non-3-card layouts) */}
        {cards.length !== 3 && secondRowCards.length > 0 && (
          <div className="grid md:grid-cols-3 gap-4">
            {secondRowCards.map((card, index) => (
              <div key={index}>
                <CardServicos
                  icon={card.icon}
                  iconHover={card.iconHover || card.icon}
                  title={card.title}
                  text={card.text}
                  glowColor={card.glowColor || '#A002CB'}
                  url={card.url}
                  className="w-full md:w-auto"
                />
              </div>
            ))}
            {/* Add empty divs to maintain grid structure if row is not full */}
            {Array.from({ length: 3 - secondRowCards.length }).map((_, i) => (
              <div key={`empty-${i}`} />
            ))}
          </div>
        )}
      </Container>

      <Container className="hidden md:block lg:hidden">
        <>
          {/* Standard layout for other card counts */}
          <div className="grid grid-cols-2 gap-4 mb-8">
            {/* Text Column */}
            <div className="text-white flex items-center justify-center h-full">
              {title}
            </div>

            {/* First row cards */}
            {firstRowCards.map((card, index) => (
              <div key={index} className="relative">
                <CardServicos
                  icon={card.icon}
                  iconHover={card.iconHover || card.icon}
                  title={card.title}
                  text={card.text}
                  glowColor={card.glowColor || '#A002CB'}
                  url={card.url}
                  className="w-full md:w-auto"
                />

              </div>
            ))}
            {secondRowCards.map((card, index) => (
              <div key={index} className="relative">
                <CardServicos
                  icon={card.icon}
                  iconHover={card.iconHover || card.icon}
                  title={card.title}
                  text={card.text}
                  glowColor={card.glowColor || '#A002CB'}
                  url={card.url}
                  className="w-full md:w-auto"
                />

              </div>
            ))}
          </div>
        </>
      </Container>

      <Container className="relative z-10 md:hidden space-y-14">
        <div className="text-3xl text-white flex justify-center text-center px-8">{title}</div>

        {/* Use AccordionServicos when there are more than 3 cards */}
        {hasMoreThanThreeCards ? (
          // Accordion layout for more than 3 cards
          <>
            {cards.map((card, index) => (
              <div key={index} className="mb-6 relative">
                <AccordionServicos
                  key={`mobile-${index}`}
                  icon={card.icon}
                  title={card.title}
                  text={card.text}
                  glowColor={card.glowColor || '#A002CB'}
                  url={card.url}
                  doesThereButton={card.doesThereButton}
                  onToggle={(isOpen) => handleAccordionToggle(index, isOpen)}
                  accordionIndex={index}
                />
                
                {/* Mobile OtimizeSeuNegocio that appears when accordion is expanded */}
                <div 
                  className={`transition-all duration-300 ease-in-out transform w-full overflow-hidden
                    ${expandedMobileIndex === index ? 'max-h-[100px] opacity-100' : 'max-h-0 opacity-0'}`}
                  style={{
                    transitionProperty: 'max-height, opacity, transform',
                    transform: expandedMobileIndex === index ? 'translateY(0)' : 'translateY(-10px)',
                    zIndex: 20,
                    position: 'relative'
                  }}
                >
                  <OtimizeSeuNegocio 
                    text="Otimize seu negócio!"
                    buttonText="Contratar"
                    useFormularioRD={true}
                    type="gradient"
                    className="w-full mt-4"
                  />
                </div>
              </div>
            ))}
          </>
        ) : (
          // CardServicos layout for 3 or fewer cards
          <>
            {firstRowCards.map((card, index) => (
              <div key={index} className="mb-6 relative">
                <AccordionServicos
                  key={`mobile-first-${index}`}
                  icon={card.icon}
                  title={card.title}
                  text={card.text}
                  glowColor={card.glowColor || '#A002CB'}
                  url={card.url}
                  doesThereButton={false}
                  onToggle={(isOpen) => handleAccordionToggle(`first-${index}`, isOpen)}
                  accordionIndex={`first-${index}`}
                  className="bg-[rgb(32,27,63)] backdrop-blur-[40px] text-left"
                />
                
                {/* Mobile OtimizeSeuNegocio that appears when accordion is expanded */}
                <div 
                  className={`transition-all duration-300 ease-in-out transform w-full overflow-hidden
                    ${expandedMobileIndex === `first-${index}` ? 'max-h-[100px] opacity-100' : 'max-h-0 opacity-0'}`}
                  style={{
                    transitionProperty: 'max-height, opacity, transform',
                    transform: expandedMobileIndex === `first-${index}` ? 'translateY(0)' : 'translateY(-10px)',
                    zIndex: 20,
                    position: 'relative'
                  }}
                >
                  <OtimizeSeuNegocio 
                    text="Otimize seu negócio!"
                    buttonText="Contratar"
                    useFormularioRD={true}
                    type="gradient"
                    className="w-full mt-4"
                  />
                </div>
              </div>
            ))}
            {secondRowCards.map((card, index) => (
              <div key={index} className="mb-6 relative">
                <AccordionServicos
                  key={`mobile-second-${index}`}
                  icon={card.icon}
                  title={card.title}
                  text={card.text}
                  glowColor={card.glowColor || '#A002CB'}
                  url={card.url}
                  doesThereButton={false}
                  onToggle={(isOpen) => handleAccordionToggle(`second-${index}`, isOpen)}
                  accordionIndex={`second-${index}`}
                  className="bg-[rgb(32,27,63)] backdrop-blur-[40px] text-left"
                />
                
                {/* Mobile OtimizeSeuNegocio that appears when accordion is expanded */}
                <div 
                  className={`transition-all duration-300 ease-in-out transform w-full overflow-hidden
                    ${expandedMobileIndex === `second-${index}` ? 'max-h-[100px] opacity-100' : 'max-h-0 opacity-0'}`}
                  style={{
                    transitionProperty: 'max-height, opacity, transform',
                    transform: expandedMobileIndex === `second-${index}` ? 'translateY(0)' : 'translateY(-10px)',
                    zIndex: 20,
                    position: 'relative'
                  }}
                >
                  <OtimizeSeuNegocio 
                    text="Otimize seu negócio!"
                    buttonText="Contratar"
                    useFormularioRD={true}
                    type="gradient"
                    className="w-full mt-4"
                  />
                </div>
              </div>
            ))}
          </>
        )}
      </Container>
    </div>
  )
}
